import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThreeDState {
    showExperience: boolean;
    isMinimized: boolean;
    shouldSaveAll: boolean;
    modelUrl: string;
    cameraPath: {
    initialPosition: [number, number, number]; // Initial camera position
    target: [number, number, number]; // Object center (look-at point)
    radius: number; // Distance from target to camera
    numViews: number; // Number of views (e.g., 12)
    heightOffset: number; // Relative height offset (e.g., 0.3)
  } | null; // Null when no path is set
}

const initialState: ThreeDState = {
    showExperience: false,
    isMinimized: false,
    shouldSaveAll: false,
    modelUrl: "",
    cameraPath: null,
};

const threeDSlice = createSlice({
    name: 'threeD',
    initialState,
    reducers: {
        setShowExperience: (state, action: PayloadAction<boolean>) => {
            state.showExperience = action.payload;
            if (!action.payload) {
                // Reset other states when hiding experience
                state.isMinimized = false;
                state.shouldSaveAll = false;
            }
        },
        
        setMinimized: (state, action: PayloadAction<boolean>) => {
            state.isMinimized = action.payload;
        },
        
        setSaveAll: (state, action: PayloadAction<boolean>) => {
            state.shouldSaveAll = action.payload;
        },
        
        setModelUrl: (state, action: PayloadAction<string>) => {
            state.modelUrl = action.payload;
        },
        
        resetThreeD: (state) => {
            state.showExperience = false;
            state.isMinimized = false;
            state.shouldSaveAll = false;
            // Keep modelUrl unchanged on reset
        },

        setCameraPath: (
            state,
            action: PayloadAction<{
                initialPosition: [number, number, number];
                target: [number, number, number];
                radius: number;
                numViews: number;
                heightOffset: number;
            } | null>
            ) => {
            state.cameraPath = action.payload;
        },
    },
});

export const { actions: threeDActions } = threeDSlice;
export default threeDSlice.reducer;